<template>
  <div class="fill-height" :style="backgroundStyle">
    <nav-bar
    ></nav-bar>

    <v-content>
      <v-container fluid>
        <router-view/>
      </v-container>
    </v-content>

    <footer-bar
    ></footer-bar>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar';
import FooterBar from '@/components/FooterBar';

import ImageBackground from '@/mixins/ImageBackground';


export default {
  components: {
    NavBar,
    FooterBar
  },

  mixins: [
    ImageBackground
  ]
};
</script>
